var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRegisterCustomerDisplayX2C = function SvgRegisterCustomerDisplayX2C(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 24,
    x: 40.5,
    y: 41.5,
    stroke: "#B3B3B3",
    rx: 0.5,
    transform: "rotate(-180 40.5 41.5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B3B3B3",
    d: "M44 15V9a3 3 0 0 0-3-3H10a3 3 0 0 0-3 3v6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B3B3B3",
    d: "M44 14v28a3 3 0 0 1-3 3H10a3 3 0 0 1-3-3V14"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 2,
    x: 18.5,
    y: 9.5,
    stroke: "#B3B3B3",
    rx: 1
  })));
};
export { SvgRegisterCustomerDisplayX2C as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNDAuNSIgeT0iNDEuNSIgd2lkdGg9IjMwIiBoZWlnaHQ9IjI0IiByeD0iMC41IiB0cmFuc2Zvcm09InJvdGF0ZSgtMTgwIDQwLjUgNDEuNSkiIHN0cm9rZT0iI0IzQjNCMyIvPgo8cGF0aCBkPSJNNDQgMTVWOUM0NCA3LjM0MzE1IDQyLjY1NjkgNiA0MSA2SDEwQzguMzQzMTUgNiA3IDcuMzQzMTUgNyA5VjE1IiBzdHJva2U9IiNCM0IzQjMiLz4KPHBhdGggZD0iTTQ0IDE0VjQyQzQ0IDQzLjY1NjkgNDIuNjU2OSA0NSA0MSA0NUgxMEM4LjM0MzE1IDQ1IDcgNDMuNjU2OSA3IDQyVjE0IiBzdHJva2U9IiNCM0IzQjMiLz4KPHJlY3QgeD0iMTguNSIgeT0iOS41IiB3aWR0aD0iMTUiIGhlaWdodD0iMiIgcng9IjEiIHN0cm9rZT0iI0IzQjNCMyIvPgo8L3N2Zz4K";